import { Route } from 'react-router-dom';

import InfoHubLayout from './layout/InfoHubLayout';
import ContentPage from './pages/Content';
import HubArchive from './pages/HubArchive';
import HubItemPage from './pages/HubItemPage';
import InfoHubMain from './pages/Main';
import NewsletterArchive from './pages/NewsletterArchive';
import NewsletterDetail from './pages/NewsletterDetail';
import {
  ARTICLE_PATH_PREFIX,
  CONTENT_PATH_PREFIX,
  HUB_HOME_PATH,
  NEWS_PATH_PREFIX,
  NEWSLETTER_PATH_PREFIX,
} from './utils/contentPaths';

/**
 * Route tree for the info hub, owned by the module — the host router only drops it in:
 * `<Routes>{infoHubRoutes}</Routes>`.
 *
 * The pages nest under `InfoHubLayout` as a layout route so the menu stays mounted across
 * navigations. React Router ranks the exact `/content` above the `/content/*` splat, so the
 * landing page and rendered content pages can share the prefix.
 *
 * Newsletters, articles and news each live on their own prefix (association-specific content),
 * kept off `/content/*` so their slugs can never collide with a content-page slug. The three
 * are peers, split on lifecycle: news is perishable, an article is not, a newsletter is an
 * issue. They share one route shape — an archive, then one item by slug.
 *
 * Note the content route prefix is `/content`, not `/info-hub`: the hub is the container, and
 * what it serves at that path are content pages. Changing it would change every page's public URL.
 *
 * The landing answers on `/content` alone. The hub does not own the site root — `/` belongs to
 * the host app (the portal sends it to `/admin`). Link via `buildHubHomePath()`.
 */
export const infoHubRoutes = (
  <Route element={<InfoHubLayout />}>
    <Route path={HUB_HOME_PATH} element={<InfoHubMain />} />
    <Route path={`/${CONTENT_PATH_PREFIX}/*`} element={<ContentPage />} />
    <Route path={`/${NEWSLETTER_PATH_PREFIX}`} element={<NewsletterArchive />} />
    <Route path={`/${NEWSLETTER_PATH_PREFIX}/:idOrSlug`} element={<NewsletterDetail />} />
    <Route path={`/${ARTICLE_PATH_PREFIX}`} element={<HubArchive kind="article" />} />
    <Route path={`/${ARTICLE_PATH_PREFIX}/:idOrSlug`} element={<HubItemPage kind="article" />} />
    <Route path={`/${NEWS_PATH_PREFIX}`} element={<HubArchive kind="news" />} />
    <Route path={`/${NEWS_PATH_PREFIX}/:idOrSlug`} element={<HubItemPage kind="news" />} />
  </Route>
);
